import React, {useCallback} from 'react'
import {Input} from '../../../../shared/Input'

// const PHONE_FIELDS = ['mobile', 'telephone']

// const handlePhoneKeyDown = e => {
//   if (e.key.length === 1 && !/\d/.test(e.key)) {
//     e.preventDefault()
//   }
// }

export function TextField({
  field,
  value,
  variant,
  size,
  disabled,
  error,
  onBlur = () => {},
  onChange,
  // Icon props — can be supplied directly or fall back to field config
  leftIcon,
  rightIcon,
  rightAction,
  onLeftIconClick,
  onRightIconClick,
}) {
  // Block letter keypresses for phone fields — mirrors old screen handlePhoneKeyDown
  const handlePhoneKeyDown = useCallback(e => {
    // Allow anything with a modifier key (Ctrl+V, Cmd+V, Ctrl+A, etc.)
    if (e.ctrlKey || e.metaKey || e.altKey) return

    if (e.key.length === 1 && /[a-zA-Z]/.test(e.key)) {
      e.preventDefault()
    }
  }, [])

  const isTelField = field.type === 'tel'

  return (
    <Input
      label={field.label}
      placeholder={field.placeholder}
      type={field.type ?? 'text'}
      maxLength={field.maxLength}
      readOnly={field.readOnly}
      value={value}
      variant={variant}
      size={size}
      disabled={disabled}
      labelLeftIcon={field.labelLeftIcon}
      infoText={field.infoText}
      infoLink={field.infoLink}
      infoLinkLabel={field.infoLinkLabel}
      infoIcon={field.infoIcon}
      linkIcon={field.linkIcon}
      helperText={field.helperText}
      leftIcon={leftIcon ?? field.leftIcon}
      rightIcon={rightIcon ?? field.rightIcon}
      rightAction={rightAction ?? field.rightAction}
      onLeftIconClick={onLeftIconClick}
      onRightIconClick={onRightIconClick}
      errorText={error}
      required={field.validators?.includes('required')}
      onChange={e => onChange(field.key, e.target.value)}
      onBlur={() => onBlur(field.key)}
      onKeyDown={isTelField ? handlePhoneKeyDown : undefined}
    />
  )
}
